"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERSONAL_SETTING = void 0;
const __1 = require("..");
exports.PERSONAL_SETTING = __1.ADMIN.child("/personalSetting");
